import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function UnitConsumedDetailContainer({ phaseLoadLogs, phaseWiseData, phase, deviceId,unit,multipleDaysLogs, name }) {
  let phaseWiseDataFilter =  phaseWiseData.filter(e=>e.ts!==undefined).sort((a, b) => a.ts - b.ts);
  let lastLog = phaseWiseDataFilter[phaseWiseDataFilter.length - 1] ?? null;
  return (
    <DetailContainer
      name={name ?? `Units Consumed ${Object.keys(phaseLoadLogs[deviceId]).length > 1 ? Number(phase) + 1 : ''}`}
      value={`${unit !== undefined ? Number(unit).toFixed(2) : 0} kwh`}
      time={
        Object.keys(phaseWiseDataFilter)?.length !== 0 &&
          phaseWiseDataFilter?.length !== 0 &&
          lastLog.ts !== undefined &&
          lastLog.ts !== null
          ? lastLog.ts
          : new Date().getTime()
      }
      showDay={multipleDaysLogs?.length > 1 ? true : false}
      hasLog={lastLog !== null}
      color={"#FDECEC"}
      borderColor={"#EF4444"}
      image={
        images.unitConsumed !== undefined ? images.unitConsumed : 0
      }
    />
  )
}

export default UnitConsumedDetailContainer